import { Divider } from '@heroui/react'
import React from 'react'

interface SectionFormTitlesProps {
	children: React.ReactNode
	description?: React.ReactNode
	className?: string
}

export default function SectionFormTitles({
	children,
	description,
	className = '',
}: SectionFormTitlesProps) {
	return (
		<>
			<div className={className}>
				<h2 className="text-xl font-semibold">{children}</h2>
				{description && <p className="text-default-500">{description}</p>}
			</div>
			<Divider className="my-4" />
		</>
	)
}
